import ApplicationResource from './ApplicationResource';
export default class PublicSettingsResource extends ApplicationResource {
  constructor() {
    super(...arguments);
    this.id = '';
    this.key = '';
    this.value = '';
  }

  pk() {
    return this.id;
  }

}
PublicSettingsResource.resource = '/settings';